import { render, staticRenderFns } from "./danhSachSuKien.vue?vue&type=template&id=ef138b08&scoped=true&"
import script from "./danhSachSuKien.vue?vue&type=script&lang=js&"
export * from "./danhSachSuKien.vue?vue&type=script&lang=js&"
import style0 from "./danhSachSuKien.vue?vue&type=style&index=0&id=ef138b08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef138b08",
  null
  
)

export default component.exports